(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[709],{

/***/ 6263:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thinking/[slug]",
      function () {
        return __webpack_require__(777);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lottie_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9260);
/* harmony import */ var lottie_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lottie_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _components_cms_ContentfulRichTextContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7981);
/* harmony import */ var _components_cms_MapPageContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1612);
/* harmony import */ var _components_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7504);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6270);
/* harmony import */ var _components_Spacing__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6435);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7734);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7479);











var PostsPage = function(param) {
    var cmsData = param.cmsData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: cmsData.pageTitle,
        url: "/thinking/".concat(cmsData.slug),
        description: cmsData.pageDescription,
        imageCTA: cmsData.metaImageCta,
        useLightTheme: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "bg-white text-almostBlack",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Grid__WEBPACK_IMPORTED_MODULE_6__/* .GridContainer */ .T5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_9__/* .H2Display */ .Zm, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: cmsData.displayTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spacing__WEBPACK_IMPORTED_MODULE_8__/* .ResponsiveSpacer */ .Yj, {
                                    size: "xs"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Typography__WEBPACK_IMPORTED_MODULE_9__/* .BaseText */ .k$, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "italic max-w-[960px]",
                                            children: cmsData.pageDescription
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spacing__WEBPACK_IMPORTED_MODULE_8__/* .ResponsiveSpacer */ .Yj, {
                                            size: "xs"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-x-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "h-[46px] w-[46px] md:h-[56px] md:w-[56px] border-[4px] rounded-full border-yellow",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        loader: function() {
                                                            return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .contentfulImageLoader */ ._u)({
                                                                src: cmsData.authorHeadshot.url,
                                                                width: 320,
                                                                quality: 95,
                                                                fit: "scale"
                                                            });
                                                        },
                                                        alt: cmsData.author,
                                                        src: cmsData.authorHeadshot.url,
                                                        layout: "responsive",
                                                        height: cmsData.authorHeadshot.height,
                                                        width: cmsData.authorHeadshot.width,
                                                        className: "rounded-full"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "-mt-[6px] font-bold",
                                                    children: cmsData.author
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spacing__WEBPACK_IMPORTED_MODULE_8__/* .ResponsiveSpacer */ .Yj, {
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Grid__WEBPACK_IMPORTED_MODULE_6__/* .GridContainer */ .T5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-full max-w-[960px]",
                            children: [
                                cmsData.animationJson && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((lottie_react__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        animationData: cmsData.animationJson
                                    })
                                }),
                                cmsData.bannerImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    loader: function() {
                                        return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .contentfulImageLoader */ ._u)({
                                            src: cmsData.bannerImage.url,
                                            width: 960,
                                            quality: 95,
                                            fit: "scale"
                                        });
                                    },
                                    alt: cmsData.pageTitle,
                                    src: cmsData.bannerImage.url,
                                    layout: "responsive",
                                    height: cmsData.bannerImage.height,
                                    width: cmsData.bannerImage.width
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spacing__WEBPACK_IMPORTED_MODULE_8__/* .ResponsiveSpacer */ .Yj, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_9__/* .BodyText */ .Ac, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "__shift-lab-rich-text-block",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_ContentfulRichTextContent__WEBPACK_IMPORTED_MODULE_4__/* .ContentfulRichTextContent */ .L, {
                                            richText: cmsData.richText
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spacing__WEBPACK_IMPORTED_MODULE_8__/* .ResponsiveSpacer */ .Yj, {
                        size: "md"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_MapPageContent__WEBPACK_IMPORTED_MODULE_5__/* .MapPageContent */ .N, {
                pageContent: cmsData.pageContentCollection.items
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PostsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,512,890,774,888,179], function() { return __webpack_exec__(6263); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);